import React from 'react';
import { useEChartsEvent } from '../../hooks';
import BubbleCommon, { commonClickDetailPageTips, TipsMapType } from '@op/components/BubbleCommon';
import './index.scss';
import { SymbolType } from '@op/constants/chart';
import { JumpType } from '@home/utils/utils';

/**
 * TODO: 优化使用方式
 * 新写法 detailPage 无意义
 * 旧：
 * export default function A() {
 *   return <div>
 *        <DetailWrapper>{() => <Element />}</DetailWrapper>
 *      </div>
 * }
 *
 * 新：
 * export default function A() {
 *   return <div>
 *         <Element />
 *      </div>
 * }
 * export function B() {
 *     return <DetailWrapper>{() => <Element />}</DetailWrapper>
 * }
 * @param props
 * @returns
 */
export default function DetailWrapper(props: {
  children: (props: {
    eventsDict: any;
    detailPage?: boolean;
    tableWrapper: (
      element: any,
      tips?: TipsMapType,
      options?: { [key: string]: any },
    ) => React.ReactNode;
    onChartReady: (chart: any) => void;
  }) => React.ReactNode;
  eventProps: {
    key: string;
    paramsKey: { [chartType in SymbolType]?: any } | string;
    defaultProps: { [key: string]: any };
    defaultFilter: { [key: string]: any };
    defaultConfig?: { [key: string]: any };
    chartType?: SymbolType;
    specialParamsKey?: { [chartType in SymbolType]?: any } | string;
  };
  updateDetailFilter?: (filter: any) => void;
  isDetail: boolean;
  [key: string]: any; // allow extra props
  formatParamsKey?: (
    key: string,
    value: string | number | any,
  ) => { [key: string]: any } | string;
  detailPage?: boolean;
  jumpType?: JumpType;
}) {
  const {
    children,
    eventProps,
    updateDetailFilter,
    isDetail,
    formatParamsKey,
    detailPage,
    jumpType,
    ...restProps
  } = props;

  function tableWrapper(
    element: any,
    tips: TipsMapType = commonClickDetailPageTips,
    options = {},
  ) {
    if (!detailPage || isDetail) {
      return <div className="dbo-detail-wrapper-table">{element}</div>;
    }

    return (
      <BubbleCommon
        placement="top"
        tipsMap={tips}
        showIcon={false}
        {...options}
      >
        <div className="dbo-detail-wrapper-table">{element}</div>
      </BubbleCommon>
    );
  }


  const { eventsDict, onChartReady, } = useEChartsEvent({
    ...eventProps,
    updateDetailFilter,
    isDetail,
    formatParamsKey,
    jumpType
  });

  return (
    <div className="dbo-detail-wrapper">
      {children({ eventsDict, detailPage, tableWrapper, onChartReady, ...restProps })}
    </div>
  );
}
